import { render, staticRenderFns } from "./AllProvincesComponent.vue?vue&type=template&id=fe744324"
import script from "./AllProvincesComponent.vue?vue&type=script&lang=js"
export * from "./AllProvincesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports